<template>
<div class="aside">
    <div class="burger" @click ="$emit('menu-toggle')" >
		<span>МЕНЮ</span>
        <v-icon name="caret-square-right" scale=2  v-if="!menu"></v-icon>
		<v-icon name="caret-square-left" scale=2  v-if="menu"></v-icon>
    </div >
    <div v-if="menu" class="formenu">
        <b-list-group-item v-for="(item,index) in items" :key = index :to="item.url"  class="pointer" @click="$emit('menu-false')">
            <div class="itemtext" >{{ item.text }}</div>
        </b-list-group-item>
    </div>

</div>
</template>

<script>
function getItems() {
    return [{
            url: '/vitrina',
            text: 'Витрина (наличие в г.Березники)',
            icon: "redo-alt"
        },
        {
            url: '/sound',
            text: 'Звуковое оборудование',
            icon: "circle"
        },
        {
            url: '/light',
            text: 'Световое оборудование',
            icon: "closed-captioning"

        },
        {
            url: '/muzinstr',
            text: 'Музыкальные инструменты',
            icon: "eject"
        },
        {
            url: '/projection',
            text: 'Проекционное оборудование',
            icon: "file-video"
        },
        {
            url: '/ferms',
            text: 'Фермовые конструкции и коммутация',
            icon: "forward"
        },
        {
            url: '/partners',
            text: 'Наши партнёры',
            icon: "music"
        },
         {
            url: '/clients',
            text: 'Клиентам',
            icon: "music"
        },
        {
            url: '/cart',
            text: 'Корзина',
            icon: "music"
        },

        {
            url: '/contacts',
            text: 'Контакты',
            icon: "closed-captioning"
        }

    ]
}

export default {
    props:['menu'],
    data() {
        return {
            items: getItems(),

        }
    }

};
</script>

<style scoped>
.formenu{
	position: fixed;
	top:40px;
	z-index: 20;
	right: 93px;
	border: 4px solid #564d76;
    border-radius: 10px;
    box-shadow: 0px 0px 50px #564d76;
}
.burger{
	position: fixed;
	cursor: pointer;
	padding: 1rem;
	z-index: 30;
	top: 10px;
    right: 10px;
	display: flex;
	flex-direction: column;
	align-items: center;
    background: #564d76ba;
    color: #fff;
    border-radius: 50%;
}
.burger span{
	font-weight: bold;
}
.aside {
    margin: 0 1rem;

}

.pointer:hover {
    cursor: pointer;
    background: #ddd;
    z-index: 10;

}

.pointer {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
}

.router-link-exact-active {
    background: #564D76 !important;
    color: #fff !important;
}

.icon {
    width: 30px;
    height: 30px;
    top: 10px;
    position: inherit;
    margin-right: 10px;
}

.itemtext {
    text-align: center;
}

@media (max-width: 600px){

	.formenu{
		width: 230px;
		top:40px;
        height: 75vh;
        overflow-y: scroll !important;
	}
    .burger{
        top:90px;
    }

}
</style>
